/**
 * Get the Salesforce Lightning base URL based on the environment
 *
 * Note: The staging/dev domain (earnedwealth2025--ewpartial) is temporary.
 * This should be updated once the proper sandbox/staging instance is configured.
 */
// The sObject types we deep-link to. Salesforce needs the type in the path even
// though the id already encodes it.
export type SalesforceObjectType = "Account" | "Case" | "Task";

export const getSalesforceLightningUrl = (
  recordId: string,
  objectType: SalesforceObjectType = "Account"
): string => {
  if (!recordId || recordId.trim() === "") {
    throw new Error("recordId is required and cannot be empty");
  }

  const isProduction =
    (process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV) ===
    "production";
  const baseUrl = isProduction
    ? "https://earnedwealth2025.lightning.force.com"
    : "https://earnedwealth2025--ewpartial.sandbox.lightning.force.com";
  return `${baseUrl}/lightning/r/${objectType}/${recordId}/view`;
};
